export = function ($stateProvider) {
    $stateProvider
    // INBOUND IOC
        .state('pages.main.inbound_ioc', {
            url: '/inbound_ioc',
            template: require('../views/ioc_notifications/inbound_ioc.html'),
            controller: 'inboundIocController',
            controllerAs: 'page',
            data: {
                title: 'Inbound Indicator of Compromise Events',
                daterange: true,
            }
        })
    // OUTBOUND IOC
        .state('pages.main.outbound_ioc', {
            url: '/outbound_ioc',
            template: require('../views/ioc_notifications/outbound_ioc.html'),
            controller: 'outboundIocController',
            controllerAs: 'page',
            data: {
                title: 'Outbound Indicator of Compromise Events',
                daterange: true,
            }
        })
    // LATERAL IOC
        .state('pages.main.lateral_ioc', {
            url: '/lateral_ioc',
            template: require('../views/ioc_notifications/lateral_ioc.html'),
            controller: 'lateralIocController',
            controllerAs: 'page',
            data: {
                title: 'Lateral Indicator of Compromise Events',
                daterange: true,
            }
        })
    // IOC EVENTS DRILLDOWN
        .state('pages.main.ioc_events_drilldown', {
                url: '/ioc_events_drilldown',
                template: require('../views/ioc_notifications/ioc_events_drilldown.html'),
                controller: 'iocEventsDrilldownController',
                controllerAs: 'page',
                data: {
                    title: 'Indicator of Compromise Events',
                    daterange: true
                }
            })
    // CUSTOM IOC
        .state('pages.main.custom_ioc', {
            url: '/custom_ioc',
            params: { include: null, time: null },
            template: require('../views/ioc_notifications/custom_ioc.html'),
            controller: 'customIOCController',
            controllerAs: 'page',
            data: {
                title: "Custom Indicator of Compromise Rules",
                daterange: false
            }
        })
    // WHITELIST
        .state('pages.main.whitelist', {
            url: '/whitelist',
            params: { include: null, time: null },
            template: require('../views/ioc_notifications/whitelist.html'),
            controller: 'whitelistController',
            controllerAs: 'page',
            data: {
                title: "Whitelist Indicator of Compromise Rules",
                daterange: false
            }
        })
    // IOC FEEDS
    //     .state('pages.main.ioc_feeds', {
    //         url: '/ioc_feeds',
    //         template: require('../views/ioc_notifications/ioc_feeds.html'),
    //         controller: 'iocFeedsController',
    //         controllerAs: 'page',
    //         data: {
    //             title: "IOC Feeds",
    //             daterange: false
    //         }
    //     })
    // AD EVENTS
        .state('pages.main.ad_events', {
            url: '/ad_events',
            template: require('../views/ioc_notifications/ad_events.html'),
            controller: 'adEventsController',
            controllerAs: 'page',
            data: {
                title: 'Active Events Defense',
                daterange: true
            }
        })
    // AD EVENTS DRILL
        .state('pages.main.ad_events_drill', {
            url: '/ad_events_drill',
            template: require('../views/ioc_notifications/ad_events_drill.html'),
            controller: 'adEventsDrillController',
            controllerAs: 'page',
            data: {
                title: 'Active Events Defense',
                daterange: true
            }
        })
    // cyr3con
        .state('pages.main.cyr3con', {
            url: '/cyr3con',
            template: require('../views/ioc_notifications/cyr3con.html'),
            controller: 'cyr3conController',
            controllerAs: 'page',
            data: {
                title: 'cyr3con',
                daterange: false,
            }
        })
}


/** WEBPACK FOOTER **
 ** ./src/pages/routes/ioc_notifications.ts
 **/